import { Reducer } from "redux";

import { AgencyStore } from "../../../types/ReduxTypes/StoreTypes";
import { SET_ADVERTISERS, SET_AGENCY } from "./types";

const initialState: AgencyStore = {
  agencyId: "",
  users: [],
  createdBy: "",
  name: "",
  email: "",
  advertisers: [],
};

const agencyReducer: Reducer<AgencyStore> = (
  state = initialState,
  // eslint-disable-next-line no-shadow
  action,
) => {
  switch (action.type) {
    case SET_AGENCY:
      return { ...action.payload };
    case SET_ADVERTISERS:
      return {
        ...state,
        advertisers: action.payload,
      };
    default:
      return state;
  }
};

export default agencyReducer;
